import { en } from './en'

export const pl = {
	...en,
  meta: {
    title: 'AuthFlow™ - Proste uwierzytelnianie e-mail/hasło z tokenami JWT',
    description: 'Niezawodne uwierzytelnianie e-mail/hasło z tokenami JWT dla nowoczesnych aplikacji webowych. W przeciwieństwie do skomplikowanych platform skupiamy się na tym, co działa: bezpiecznym, prostym logowaniu, któremu programiści mogą zaufać.',
  },
	nav: {
		home: 'Strona glowna',
		features: 'Funkcje',
		pricing: 'Cennik',
		compare: 'Porownaj',
		contact: 'Kontakt',
		getStarted: 'Zacznij',
		signIn: 'Zaloguj sie',
	},
	hero: {
		badge: 'Zaufane przez zespoly DevSecOps na calym swiecie',
		title: 'Uwierzytelnianie',
		subtitle: 'zrobione dobrze',
		description: 'Najlepsze, najszybsze i najbezpieczniejsze uwierzytelnianie e-mail/haslo. Zamiast przesadnie zlozonych platform skupiamy sie na tym, co wazne: bezpieczne JWT, ktore po prostu dziala.',
		startTrial: 'Rozpocznij darmowy okres probny',
		getStarted: 'Zacznij',
			trialNote: 'Bez karty kredytowej • 10 Miesięcznych Aktywnych Użytkowników za darmo',
		metrics: {
			firstIntegrationValue: '5 min',
			firstIntegrationLabel: 'do pierwszej integracji',
			predictableSessionsValue: 'JWT',
			predictableSessionsLabel: 'sesje, ktore pozostaja przewidywalne',
			noMazeValue: 'Bez labiryntu',
			noMazeLabel: 'dla zespolow, ktore chca po prostu dzialajacego auth',
		},
		missionControlLabel: 'Centrum kontroli auth',
		missionControlTitle: 'Uwierzytelnianie użytkowników bez labiryntu',
		missionControlStatus: 'Stabilne',
		sessionLayer: 'Warstwa sesji',
		emailPasswordSignIn: 'Logowanie e-mail/haslo',
		roleAwareVerification: 'Weryfikacja swiadoma roli',
		validated: 'zweryfikowane',
		live: 'na zywo',
		integrationShapeLabel: 'Ksztalt integracji',
		integrationShapeValue: 'Male API, klarowny przeplyw',
		forTeamsLabel: 'Dla zespolow',
		forTeamsValue: 'Wysylaj produkt, nie projekty IAM',
	},
	cta: {
		title: 'Gotowy dodac niezawodne uwierzytelnianie?',
		description: 'Dolacz do zespolow, ktore wybieraja proste i skuteczne uwierzytelnianie e-mail/haslo z JWT. Zacznij darmowy okres probny juz dzis.',
		startTrial: 'Rozpocznij darmowy okres probny',
	},
	dashboard: {
		title: 'Panel',
		users: 'Uzytkownicy',
		activity: 'Aktywnosc',
		settings: 'Ustawienia',
		logout: 'Wyloguj',
		profileSettings: 'Ustawienia profilu',
		activityLog: 'Dziennik aktywnosci',
		welcome: 'Witamy w panelu',
		welcomeBack: 'Witamy ponownie, {name}. Oto co dzieje sie z Twoja usluga uwierzytelniania.',
		totalUsers: 'Laczna liczba uzytkownikow',
		activeUsers: 'Aktywni uzytkownicy',
		totalLogins: 'Laczna liczba logowan',
		recentActivity: 'Ostatnia aktywnosc',
		noRecentActivity: 'Brak ostatniej aktywnosci',
		userSettings: 'Ustawienia uzytkownika',
		organizationOwnerCannotBeManaged: 'Wlasciciel organizacji nie moze byc zarzadzany',
		configureSettings: 'Skonfiguruj ustawienia',
		hereIsWhatsHappening: 'Oto co dzieje sie z Twoja usluga uwierzytelniania.',
		fromLastMonth: 'wzgledem poprzedniego miesiaca',
		monthlyLogins: 'Miesieczne logowania',
		successRate: 'Wskaznik sukcesu',
		latestAuthEvents: 'Najnowsze zdarzenia uwierzytelniania i aktualizacje systemu',
		viewAllActivity: 'Zobacz cala aktywnosc',
		userManagement: 'Zarzadzanie uzytkownikami',
		manageApplicationUsers: 'Zarzadzaj uzytkownikami aplikacji',
		viewAllUsers: 'Zobacz wszystkich uzytkownikow',
		apiKeys: 'Klucze API',
		manageApiKeys: 'Zarzadzaj kluczami API uwierzytelniania',
		systemStatus: 'Status systemu',
		authenticationApi: 'API uwierzytelniania',
		operational: 'Dziala',
		userManagementService: 'Zarzadzanie uzytkownikami',
		searchUsers: 'Szukaj uzytkownikow...',
		all: 'Wszyscy',
		active: 'Aktywni',
		inactive: 'Nieaktywni',
		lastLogin: 'Ostatnie logowanie',
		never: 'Nigdy',
		admin: 'Admin',
		owner: 'Wlasciciel',
		noUsersFound: 'Nie znaleziono uzytkownikow spelniajacych kryteria',
		noUsers: 'Nie znaleziono uzytkownikow',
		for: 'dla',
		noApiKeyFound: 'Nie znaleziono klucza API',
		hideApiKey: 'Ukryj klucz API',
		showApiKey: 'Pokaz klucz API',
		created: 'Utworzono',
		success: 'Sukces',
		warning: 'Ostrzezenie',
		info: 'Info',
		system: 'System',
		justNow: 'przed chwila',
		minutesAgo: 'minut temu',
		hoursAgo: 'godzin temu',
		daysAgo: 'dni temu',
		notifications: 'Powiadomienia',
		billingReminder: 'Przypomnienie o platnosci',
		noNewNotifications: 'Brak nowych powiadomien',
		logOut: 'Wyloguj',
	},
	about: {
		title: 'O AuthFlow™ - Eksperci od prostego uwierzytelniania e-mail/haslo',
		description: 'Poznaj misje AuthFlow™: niezawodne uwierzytelnianie e-mail/haslo z tokenami JWT.',
		keywords: ['uwierzytelnianie email haslo', 'firma JWT auth', 'eksperci uwierzytelniania', 'proste uwierzytelnianie', 'firma bezpiecznego logowania', 'uwierzytelnianie deweloperskie', 'niezawodne uwierzytelnianie', 'uwierzytelnianie tokenowe', 'bezpieczenstwo aplikacji web', 'platforma uwierzytelniania'],
		ogTitle: 'O AuthFlow™ - Eksperci od prostego uwierzytelniania e-mail/haslo',
		ogDescription: 'Poznaj nasza misje zapewnienia niezawodnego uwierzytelniania e-mail/haslo z JWT.',
		hero: {
			badge: 'Zalozone w 2023',
			title: 'Budujemy przyszlosc',
			titleAccent: 'prostego uwierzytelniania',
			description: 'Nasza misja jest udostepnienie kazdemu deweloperowi prostego uwierzytelniania e-mail/haslo z JWT.',
		},
		mission: {
			title: 'Nasza misja',
			description1: 'Upowszechniac bezpieczne, tokenowe uwierzytelnianie latwe do wdrozenia i utrzymania.',
			description2: 'Priorytetem sa prywatnosc i zgodnosc, przy minimalnej kolekcji danych i silnym szyfrowaniu.',
			description3: 'Dzieki temu deweloperzy moga skupic sie na tworzeniu produktow, a nie na nadmiernie zlozonej infrastrukturze auth.',
		},
		vision: {
			title: 'Nasza wizja',
			description1: 'Swiat, w ktorym uwierzytelnianie jest proste i niezawodne.',
			description2: 'Tworzymy infrastrukture bezpiecznego i prostego logowania, na ktorej deweloperzy moga polegac.',
		},
		values: {
			title: 'Nasze wartosci',
			subtitle: 'Zasady, ktore prowadza wszystko, co robimy w AuthFlow™.',
			reliableSecurity: { title: 'Niezawodne bezpieczenstwo', description: 'Stawiamy na sprawdzone praktyki bezpieczenstwa bez zbednej zlozonosci.' },
			developerFirst: { title: 'API dla deweloperow', description: 'Dbamy o intuicyjne narzedzia i dobra dokumentacje, by poprawic developer experience.' },
			communityDriven: { title: 'Naprzadzane przez spolecznosc', description: 'Roadmapa jest tworzona na podstawie realnych potrzeb i feedbacku deweloperow.' },
		},
		team: {
			title: 'Nasz zespol',
			subtitle: 'Ludzie, ktorzy buduja przyszlosc uwierzytelniania.',
			alex: { initials: 'AJ', name: 'Alex Johnson', role: 'CEO & Co-Founder', bio: 'Byly DevSecOps w duzej miedzynarodowej instytucji finansowej.' },
			sarah: { initials: 'SC', name: 'Sarah Chen', role: 'CTO & Co-Founder', bio: 'Architekt full-stack z ponad 10-letnim doswiadczeniem w systemach auth.' },
			marcus: { initials: 'MR', name: 'Marcus Rodriguez', role: 'Head of Product', bio: 'Lider produktu skupiony na developer experience i niezawodnym auth.' },
		},
		stats: { title: 'AuthFlow™ w liczbach', developers: 'Deweloperow nam ufa', authentications: 'Miesieczne uwierzytelnienia', uptime: 'Dostepnosc', monitoring: 'Monitoring bezpieczenstwa' },
		cta: { title: 'Dolacz do naszej misji', description: 'Gotowy byc czescia rewolucji uwierzytelniania?', getStarted: 'Zacznij za darmo', contactUs: 'Skontaktuj sie' },
		breadcrumb: { company: 'Firma', aboutUs: 'O nas' },
	},
	getStarted: {
		...en.getStarted,
		title: 'AuthFlow™ Zacznij - Przewodnik konfiguracji uwierzytelniania e-mail/haslo | Integracja API JWT',
		description: 'Kompletny przewodnik wdrozenia uwierzytelniania e-mail/haslo z AuthFlow™. Skonfiguruj bezpieczne logowanie JWT w kilka minut.',
		keywords: ['konfiguracja uwierzytelniania', 'uwierzytelnianie email haslo', 'integracja JWT', 'przewodnik bezpiecznego logowania', 'uwierzytelnianie deweloperskie', 'tutorial API auth', 'uwierzytelnianie tokenowe', 'przewodnik API auth'],
		ogTitle: 'AuthFlow™ Zacznij - Przewodnik konfiguracji uwierzytelniania e-mail/haslo | Integracja API JWT',
		ogDescription: 'Wdrozenie AuthFlow™ email/haslo i konfiguracja JWT w kilka minut.',
		breadcrumb: { resources: 'Zasoby', getStarted: 'Zacznij' },
		hero: {
			...en.getStarted.hero,
			badge: 'Szybki przewodnik konfiguracji',
			title: 'Zacznij z',
			titleAccent: 'uwierzytelnianiem e-mail/haslo',
			description: 'Dodaj bezpieczne logowanie e-mail/haslo do aplikacji w kilka minut.',
			createAccount: 'Utworz darmowe konto',
		},
		steps: {
			...en.getStarted.steps,
			title: 'Trzy proste kroki do bezpiecznego uwierzytelniania e-mail/haslo',
			subtitle: 'Wykonaj te kroki, aby zintegrowac endpointy AuthFlow™ w backendzie.',
			step1: { ...en.getStarted.steps.step1, title: 'Utworz konto', description: 'Zarejestruj sie w AuthFlow™ i utworz pierwszy projekt.', signUp: 'Zarejestruj za darmo', viewDemo: 'Zobacz demo' },
			step2: { ...en.getStarted.steps.step2, title: 'Zintegruj endpointy auth', description: 'Uzyj endpointow /auth po stronie backendu.' },
			step3: { ...en.getStarted.steps.step3, title: 'Dodaj uwierzytelnianie', description: 'Polacz aplikacje i zacznij korzystac z komponentow auth.', quickStart: 'Szybki start', fullDocumentation: 'Pelna dokumentacja' },
		},
		apiDocs: { ...en.getStarted.apiDocs, title: 'Techniczny przewodnik endpointow API /auth', subtitle: 'Pelna dokumentacja techniczna integracji endpointow AuthFlow™.' },
		features: { ...en.getStarted.features, title: 'Co otrzymujesz od razu z uwierzytelnianiem e-mail/haslo', subtitle: 'Ty podlaczasz endpointy, my dostarczamy niezawodne sesje JWT.' },
		cta: { ...en.getStarted.cta, title: 'Gotowy dodac niezawodne uwierzytelnianie e-mail/haslo?', description: 'Rozpocznij darmowy okres probny juz dzis i uruchom JWT jeszcze dzisiaj.', createAccount: 'Utworz darmowe konto', talkToSales: 'Porozmawiaj ze sprzedaza' },
		parameters: 'Parametry',
		response: 'Odpowiedz',
		example: 'Przyklad',
		runFailureScenario: 'Uruchom jako scenariusz bledu',
		failureScenarioOn: 'Scenariusz bledu: Wlaczony',
		running: 'Uruchamianie...',
		runCurlConsole: 'Uruchom cURL w konsoli',
		copied: 'Skopiowano!',
		copyCurl: 'Kopiuj curl',
		copyBackendExample: 'Kopiuj kod backendu',
		required: 'wymagane',
		optional: 'opcjonalne',
		consoleRunning: 'Konsola dziala...',
		consoleDemoTitle: 'Demo konsoli Linux',
		consoleShellLabel: 'bash -- Konsola AuthFlow™',
		notesTitle: 'Notatki',
		endpointContent: {
			session: {
				fooBar: {
					summary: 'Wygeneruj krotko zyjacy token anti-abuse przed sign-up lub login.',
					params: {
						identity: 'Adres email auth usera.',
						apiKey: 'API key organizacji z dashboardu ownera AuthFlow™.',
						role: 'Rola RBAC kodowana w tymczasowym tokenie. Domyslnie user.',
					},
					notes: {
						expires: 'Ten token wygasa po 45 sekundach.',
						freshToken: 'Pobieraj swiezy token fooBar bezposrednio przed sign-up lub login.',
					},
				},
				signUp: {
					summary: 'Utworz nowego auth usera w organizacji ownera.',
					params: {
						foobar: 'Tymczasowy token anti-abuse z /auth/fooBar.',
						email: 'Adres email uzytkownika.',
						password: 'Haslo zgodne z {passwordRule}.',
						fullname: 'Pelna nazwa auth usera.',
						role: 'Rola RBAC usera w Twojej aplikacji.',
						apiKey: 'API key organizacji.',
						disclaimed: 'Wartosc boolopodobna zapisywana przy userze. W kolekcji: true.',
					},
					notes: {
						successToken: 'Udany sign-up od razu zwraca session token.',
						duplicateRole: 'Jesli ten sam email+rola juz istnieja, API zwroci 409.',
					},
				},
				login: {
					summary: 'Uwierzytelnij auth usera i zwroc session token albo wyzwanie 2FA.',
					params: {
						foobar: 'Tymczasowy token anti-abuse z /auth/fooBar.',
						email: 'Adres email uzytkownika.',
						password: 'Haslo uzytkownika.',
						apiKey: 'API key organizacji.',
						role: 'Rola usera dla logowania RBAC.',
					},
					notes: {
						tempTokenInsteadOfToken: 'Gdy 2FA jest wlaczone, login zwraca tempToken zamiast tokenu.',
						exchangeThrough2fa: 'tempToken trzeba wymienic przez odpowiedni endpoint /auth/2fa.',
					},
				},
				validate: {
					summary: 'Zweryfikuj session token auth usera.',
					params: {
						sessionToken: 'RS512 JWT session token.',
						email: 'Adres email uzytkownika.',
					},
				},
				me: {
					summary: 'Zwroc aktualny profil auth usera dla prawidlowej sesji.',
					params: {
						sessionToken: 'RS512 JWT session token.',
					},
				},
				logout: {
					summary: 'Wyloguj aktualnego auth usera.',
					params: {
						sessionToken: 'RS512 JWT session token.',
						email: 'Adres email uzytkownika.',
					},
				},
			},
			passwordManagement: {
				forgotPassword: {
					summary: 'Wyslij zadanie o email resetu hasla dla auth usera (odporny na enumeracje).',
					params: {
						email: 'Adres email auth usera.',
						apiKey: 'API key organizacji.',
						role: 'Rola auth usera. Domyslnie user.',
					},
				},
				resetPassword: {
					summary: 'Zresetuj haslo auth usera prawidlowym tokenem resetu.',
					params: {
						token: 'Token resetu hasla z linku email.',
						newPassword: 'Nowe haslo zgodne z {passwordRule}.',
					},
				},
				changePassword: {
					summary: 'Zmien haslo zalogowanego auth usera.',
					params: {
						sessionToken: 'Biezacy RS512 JWT session token.',
						email: 'Email zakodowany w session tokenie.',
						oldPassword: 'Aktualne haslo do potwierdzenia.',
						newPassword: 'Nowe haslo zgodne z {passwordRule}.',
					},
				},
			},
			emailVerification: {
				verifyEmail: {
					summary: 'Zweryfikuj email auth usera tokenem dostarczonym przez email AuthFlow™.',
					params: {
						token: 'Token weryfikacyjny z linku email.',
					},
					notes: {
						openedFromEmail: 'Ten endpoint zwykle otwierany jest po kliknieciu linku weryfikacyjnego w emailu.',
						frontendHostedProxy: 'AuthFlow™ wspiera tez frontend-hosted weryfikacje przez /verify-email.',
					},
				},
				resendVerifyEmail: {
					summary: 'Wyslij ponownie email weryfikacyjny, gdy konto nie jest jeszcze zweryfikowane.',
					params: {
						foobar: 'Tymczasowy token z /auth/fooBar.',
						email: 'Adres email auth usera.',
						apiKey: 'API key organizacji.',
						role: 'Rola auth usera. Domyslnie user.',
					},
				},
			},
			twoFactor: {
				enable: {
					summary: 'Wygeneruj sekret TOTP i kod QR dla auth usera.',
					params: { sessionToken: 'Biezacy session token.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.' },
				},
				verifySetup: {
					summary: 'Zweryfikuj poczatkowy kod TOTP i wlacz 2FA.',
					params: { sessionToken: 'Biezacy session token.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', totpCode: 'Szescio-cyfrowy kod z aplikacji authenticator.', secret: 'Sekret TOTP z /auth/2fa/enable.' },
				},
				disable: {
					summary: 'Wylacz TOTP 2FA dla auth usera.',
					params: { sessionToken: 'Biezacy session token.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', password: 'Aktualne haslo.' },
				},
				verify2fa: {
					summary: 'Wymien login tempToken i kod TOTP na session token.',
					params: { tempToken: 'tempToken zwrocony przez /auth/login gdy 2FA jest wlaczone.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', totpCode: 'Szescio-cyfrowy kod authenticatora.' },
				},
				backupEmail: {
					summary: 'Wyslij zapasowy email OTP uzywajac login tempToken.',
					params: { tempToken: 'tempToken z /auth/login.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.' },
				},
				verifyEmailOtp: {
					summary: 'Wymien OTP z emaila na session token.',
					params: { email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', emailOtp: 'Szescio-cyfrowy kod dostarczony emailem.' },
				},
				recoveryCodes: {
					summary: 'Wygeneruj ponownie recovery codes dla auth usera.',
					params: { sessionToken: 'Biezacy session token.', email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', password: 'Aktualne haslo.' },
				},
				verifyRecovery: {
					summary: 'Wymien recovery code na session token.',
					params: { email: 'Email auth usera.', apiKey: 'UUID organizacji.', role: 'Rola auth usera.', recoveryCode: 'Jeden z 8-znakowych recovery codes zwroconych wczesniej.' },
				},
			},
			environment: {
				baseUrl: 'Publiczny origin API.',
				apiKey: 'API key z dashboardu ownera. Przechowywac tylko po stronie serwera.',
				defaultRole: 'Wartosc roli/RBAC przypisywana auth userowi.',
			},
		},
		console: {
			...en.getStarted.console,
			launching: 'Uruchamianie AuthFlow™ Linux Console v1.0 ...',
			connected: 'Polaczono z api.authflow.net',
			sending: '> Wysylanie {method} {path}',
			waiting: '> Oczekiwanie na odpowiedz ...',
			processExited: '[proces zakonczony kodem {code}]',
			status: {
				...en.getStarted.console.status,
				defaultSuccess: 'HTTP/1.1 200 OK (przyklad)',
				signup: { ...en.getStarted.console.status.signup, success: 'HTTP/1.1 201 Created (przyklad)', alt409: '# alt: HTTP/1.1 409 Conflict gdy email+rola juz istnieja' },
				login: { ...en.getStarted.console.status.login, success: 'HTTP/1.1 200 OK (przyklad)', alt2fa: '# alt: zwraca payload requires2FA/tempToken gdy 2FA jest wlaczone' },
				verifyEmail: { ...en.getStarted.console.status.verifyEmail, success: 'HTTP/1.1 200 OK (przyklad)', alt401: '# alt: HTTP/1.1 401 Unauthorized dla niewaznego lub wygaslego tokenu weryfikacji' },
				validate: { ...en.getStarted.console.status.validate, success: 'HTTP/1.1 200 OK (przyklad)', alt401: '# alt: HTTP/1.1 401 Unauthorized dla niewaznego lub wygaslego session tokenu' },
				forgotPassword: { ...en.getStarted.console.status.forgotPassword, success: 'HTTP/1.1 200 OK (odpowiedz anti-enumeration)' },
				changePassword: { ...en.getStarted.console.status.changePassword, success: 'HTTP/1.1 200 OK (przyklad)', noJsonBody: '# brak JSON body przy sukcesie' },
			},
			failure: {
				...en.getStarted.console.failure,
				signup: { ...en.getStarted.console.failure.signup, status: 'HTTP/1.1 409 Conflict (przyklad)', extra: '# scenariusz bledu: duplikat email+rola' },
				login: { ...en.getStarted.console.failure.login, status: 'HTTP/1.1 400 Bad Request (przyklad)', extra: '# scenariusz bledu: niepoprawne dane logowania lub mismatch roli' },
				verifyEmail: { ...en.getStarted.console.failure.verifyEmail, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: przeterminowany token weryfikacji' },
				validate: { ...en.getStarted.console.failure.validate, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: wygasly session token' },
				me: { ...en.getStarted.console.failure.me, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: brakujacy lub niewazny sessionToken' },
				logout: { ...en.getStarted.console.failure.logout, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: niewazny sessionToken' },
				changePassword: { ...en.getStarted.console.failure.changePassword, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: oldPassword niepoprawne lub sesja wygasla' },
				resendVerifyEmail: { ...en.getStarted.console.failure.resendVerifyEmail, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: wygasly foobar token lub niepoprawny api_key' },
				fooBar: { ...en.getStarted.console.failure.fooBar, status: 'HTTP/1.1 400 Bad Request (przyklad)', extra: '# scenariusz bledu: brak identity lub api_key' },
				forgotPassword: { ...en.getStarted.console.failure.forgotPassword, status: 'HTTP/1.1 400 Bad Request (przyklad)', extra: '# scenariusz bledu: brak email lub api_key' },
				resetPassword: { ...en.getStarted.console.failure.resetPassword, status: 'HTTP/1.1 401 Unauthorized (przyklad)', extra: '# scenariusz bledu: wygasly reset token' },
				default: { ...en.getStarted.console.failure.default, status: 'HTTP/1.1 400 Bad Request (przyklad)', extra: '# scenariusz bledu' },
			},
		},
		pageContent: {
			...en.getStarted.pageContent,
			badge: 'Referencja produktu auth',
			title: 'Dokumentacja API AuthFlow™',
			titleAccent: 'dla wlascicieli organizacji',
			description: 'Ta strona Get Started dokumentuje publiczne API auth dla uzytkownikow Twojej organizacji. AuthFlow™ udostepnia lacznie 20 tras /auth.',
			downloadCollection: 'Pobierz kolekcje Insomnia',
			createAccount: 'Utworz konto ownera',
			cloneStarterOnGitHub: 'Sklonuj starter Next.js',
			starterInfoLabel: 'Wazne informacje o bezpieczenstwie startera Next.js',
			starterWarningTitle: 'Tylko do prototypow i proof of concept',
			starterWarningPrototype: 'authflow-nextjs-starter jest przeznaczony wylacznie do prototypow i frontendow typu proof of concept. Nie jest to integracja przegladarkowa do uzycia produkcyjnego.',
			starterWarningSecret: 'Nigdy nie umieszczaj klucza API AuthFlow w produkcyjnym kodzie frontendu, zmiennych srodowiskowych widocznych dla przegladarki, zasobach statycznych ani pakietach klienta. Wszystko wyslane do przegladarki moze zostac odczytane przez uzytkownikow i atakujacych.',
			starterWarningProduction: 'W produkcji kieruj zadania uwierzytelniania przez zaufany backend serwerowy lub proxy AuthFlow ExpressJS, a klucz API przechowuj w serwerowych zmiennych srodowiskowych albo zarzadzanym magazynie sekretow.',
			apiKeyWarningTitle: 'Nigdy nie ujawniaj klucza API AuthFlow w produkcyjnym kodzie przegladarki.',
			apiKeyWarningBody: 'Klucze API musza pozostac w kontrolowanej przez Ciebie infrastrukturze. Nie osadzaj ich w pakietach JavaScript, HTML, publicznych zmiennych srodowiskowych, mobilnych zasobach webowych, logach ani zadaniach sieciowych wysylanych bezposrednio przez przegladarke. Uzyj tego proxy ExpressJS lub wlasnego backendu, aby klucz pozostal po stronie serwera.',
			integrationRulesTitle: 'Zasady integracji',
			integrationRulesRules: ['Wlasciciel organizacji wywoluje AuthFlow™ tylko z kodu serwerowego.', 'API key ownera jest wymagany dla kluczowych tras sesji.', 'fooBar pobieraj tuz przed sign-up/login, by byl swiezy.', 'Jesli login zwroci requires2FA, wykonaj jeden z przeplywow /auth/2fa.'],
			ownerAssetsTitle: 'Materialy ownera',
			ownerAssetsText: 'Uzyj dokladnie tej kolekcji, ktora zespol moze zaimportowac do Insomnia.',
			collectionIncludes: 'Kolekcja zawiera:',
			collectionItems: ['7 publicznych tras sesji /auth', '3 publiczne trasy /auth passwordManagement', '2 publiczne trasy /auth emailVerification', '8 publicznych tras /auth/2fa', 'Zmienne srodowiskowe dla API key, roli/RBAC, session token, TOTP, temp token i recovery code'],
			checklistTitle: 'Lista kontrolna implementacji',
			checklistSubtitle: 'To rekomendowany workflow ownera organizacji do podlaczenia uwierzytelniania przez AuthFlow™.',
			configStep: '1. Skonfiguruj sekrety po stronie serwera',
			implementStep: '2. Zaimplementuj auth po stronie serwera',
			connectStep: '3. Podlacz frontend',
			connectStepSecurityNote: 'Kod przegladarki nigdy nie powinien przechowywac sekretow API AuthFlow™, takich jak owner API key.',
			implementStepRules: ['/auth/fooBar', '/auth/signUp lub /auth/login', 'Bezpiecznie przechowuj tokeny sesji', 'Uzywaj /auth/validate, /auth/me, /auth/changePassword i /auth/logout na trasach chronionych'],
			connectStepRules: ['Wysylaj formularze logowania i rejestracji', 'Obsluz prompty 2FA, gdy API zwroci requires2FA', 'Przechowuj sesje aplikacji w bezpiecznych cookies', 'Laduj aktualnego uzytkownika przez odpowiedzi endpointow sesji'],
			sessionEndpointsTitle: 'Endpointy sesji',
			sessionEndpointsSubtitle: 'Te 7 tras odpowiada authProduct.session z backendowego root endpointu.',
			passwordMgmtTitle: 'Endpointy zarzadzania haslem',
			passwordMgmtSubtitle: 'Te 3 trasy odpowiadaja authProduct.passwordManagement.',
			emailVerificationTitle: 'Endpointy weryfikacji e-mail',
			emailVerificationSubtitle: 'Te 2 trasy odpowiadaja authProduct.emailVerification.',
			twoFactorTitle: 'Endpointy 2FA',
			twoFactorSubtitle: 'Te 8 tras odpowiada authProduct.twoFactor.',
			serviceExampleTitle: 'Przyklad serwisu',
			securityRequirementsTitle: 'Wymagania bezpieczenstwa',
			securityRequirements: ['Trzymaj AUTHFLOW_API_KEY po stronie serwera i zaszyfrowany.', 'Preferuj HTTP-only secure cookies dla sesji aplikacji.', 'Waliduj sesje AuthFlow™ przed zwrotem chronionych danych.', 'Obsluguj jawnie odpowiedzi 400, 401, 404, 409 i 500.'],
			readyCtaTitle: 'Gotowy podlaczyc uwierzytelnianie firmy?',
			readyCtaDescription: 'Zacznij od kolekcji do pobrania, wdroz bezpieczna integracje i skorzystaj z asystenta na tej stronie, jesli potrzebujesz wsparcia.',
			proxyDescriptionPrefix: 'Mozesz tez zrobic proxy backendu AuthFlow przez wlasny backend ExpressJS. To jedna z najbezpieczniejszych metod korzystania z ',
			proxyDescriptionSuffix: ' w stackach aplikacyjnych.',
			proxyDetailsRoutes: 'Proxy przekazuje wszystkie trasy AuthFlow /auth/* i /auth/2fa/*, trzyma API key po stronie serwera i ogranicza ryzyko wycieku sekretow.',
			proxyDetailsDeploy: 'Proxy jest gotowe pod Vercel, od razu wspiera lokalny development i zawiera przyklady dla sign-up, login, password flow i 2FA.',
			proxyButton: 'Zobacz na GitHub',
		},
	},
	comparisons: {
		...en.comparisons,
		hub: {
			...en.comparisons.hub,
			breadcrumbRoot: 'Porownaj',
			breadcrumbCurrent: 'Porownania produktow auth',
			title: 'Porownania produktow auth',
			description: 'Sprawdz, jak AuthFlow™ wypada na tle najpopularniejszych platform auth. Tabele funkcji obok siebie ulatwiaja wybor odpowiedniej warstwy uwierzytelniania dla twojego projektu.',
			card: {
				firebase: {
					title: 'Firebase vs. Auth0 vs. AuthFlow™',
					description: 'Porownaj Google Firebase Authentication, enterprise platforme Auth0 oraz podejscie AuthFlow™ skoncentrowane na deweloperach. Szybko zobaczysz, ktore rozwiazanie najlepiej pasuje do twojego stacku.',
				},
				supabase: {
					title: 'Supabase vs. Auth0 vs. AuthFlow™',
					description: 'Porownaj open-source auth od Supabase, enterprise funkcje Auth0 oraz lekkie, skoncentrowane podejscie AuthFlow™. Szczegolnie przydatne, jesli juz pracujesz w ekosystemie Supabase.',
				},
			},
			bullets: {
				core: 'Podstawowe funkcje auth i bezpieczenstwo',
				rbac: '2FA, RBAC i wielodostepnosc',
				supabaseModel: 'Open source vs. managed vs. wyspecjalizowane',
				pricing: 'Cennik i vendor lock-in',
				dx: 'Developer experience i zlozonosc wdrozenia',
			},
			viewComparison: 'Zobacz porownanie',
		},
		labels: {
			...en.comparisons.labels,
			fullySupported: 'W pelni wspierane',
			partial: 'Czesciowe / ograniczone',
			notSupported: 'Brak wsparcia',
			feature: 'Funkcja',
			summary: 'Podsumowanie',
			startFree: 'Zacznij za darmo z AuthFlow™',
			alsoSee: 'Zobacz tez:',
			providers: {
				firebase: 'Firebase Auth',
				supabase: 'Supabase Auth',
				auth0: 'Auth0',
				authflow: 'AuthFlow™',
			},
			categories: { ...en.comparisons.labels.categories, core: 'Podstawowe uwierzytelnianie', security: 'Bezpieczenstwo', userOrg: 'Zarzadzanie uzytkownikami i organizacjami', dx: 'Doswiadczenie dewelopera', pricing: 'Cennik i elastycznosc' },
		},
		features: {
			emailPassword: 'Uwierzytelnianie e-mail i haslo',
			socialLogin: 'Logowanie spolecznosciowe (Google, GitHub itd.)',
			magicLinks: 'Magic linki / passwordless',
			smsPhone: 'Uwierzytelnianie SMS / telefon',
			anonymous: 'Uwierzytelnianie anonimowe',
			jwt: 'Zarzadzanie tokenami JWT',
			rs512: 'Podpisywanie kluczem RS512',
			twofa: 'Uwierzytelnianie dwuskladnikowe (2FA)',
			totp: 'Aplikacja TOTP (Google Auth, Authy)',
			backupCodes: 'Kody zapasowe 2FA',
			emailOtp: '2FA przez e-mail OTP',
			rateLimiting: 'Rate limiting',
			emailVerification: 'Weryfikacja e-mail',
			passwordReset: 'Reset hasla / przypomnienie hasla',
			passwordComplexity: 'Wymuszanie zlozonosci hasla',
			userDashboard: 'Panel zarzadzania uzytkownikami',
			rbac: 'Role-Based Access Control (RBAC)',
			multiTenancy: 'Wielodostepnosc / Organizacje',
			perOrgApiKeys: 'Klucze API per organizacja',
			auditLogs: 'Logi audytu / aktywnosci',
			userBlocking: 'Blokowanie / zawieszanie uzytkownikow',
			simpleRest: 'Proste REST API (bez SDK)',
			officialSdks: 'Oficjalne SDK klienckie',
			customEmailTemplates: 'Wlasne szablony e-mail',
			webhooks: 'Webhooki / callbacki zdarzen',
			selfHosted: 'Opcja self-hosted',
			openSource: 'Open source',
			apiDocs: 'Dokumentacja API',
			integratedDb: 'Zintegrowana baza danych (PostgreSQL)',
			authOnly: 'Tylko auth (bez wymaganej bazy danych)',
			freeTier: 'Dostepny darmowy plan',
			flatRate: 'Przewidywalny abonament staly',
			payPerMau: 'Model platnosci za MAU',
			lowLockIn: 'Niski vendor lock-in',
			lowSetup: 'Niska zlozonosc wdrozenia',
			noEcosystemBuyIn: 'Dziala bez wejscia w caly ekosystem',
		},
		notes: {
			firebase2fa: 'Firebase wymaga przejscia na Identity Platform, aby uzyskac 2FA.',
			firebaseRest: 'Firebase jest nastawiony na SDK; czyste REST wymaga recznej wymiany tokenow.',
			firebaseLockIn: 'Firebase jest mocno powiazany z ekosystemem Google/Firebase.',
			supabaseRls: 'Supabase korzysta z polityk Row-Level Security (RLS) w Postgresie.',
			supabaseDb: 'Supabase Auth jest scisle zintegrowane z baza Postgres.',
			supabaseLockIn: 'Open source ogranicza lock-in, ale warstwa auth nadal jest powiazana ze stackiem Postgres.',
			supabaseAuthOnly: 'Supabase mozna uzywac tylko do auth, ale zaprojektowano je jako pelna platforme backendowa.',
		},
		firebase: {
			...en.comparisons.firebase,
			breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
			title: 'Firebase vs. Auth0 vs. AuthFlow™',
			description: 'Porownanie Google Firebase Authentication, Okta Auth0 i AuthFlow™ krok po kroku, aby ulatwic wybor odpowiedniej warstwy auth dla twojej aplikacji.',
			summary: {
				firebaseTitle: 'Firebase Authentication',
				firebaseBody: 'Najlepszy wybor dla zespolow mocno zwiazanych z ekosystemem Google/Firebase. Hojny darmowy plan i wygodna integracja przez SDK, ale duzy lock-in oraz potrzeba Identity Platform przy bardziej zaawansowanych funkcjach, takich jak 2FA.',
				auth0Title: 'Auth0',
				auth0Body: 'Najszerszy zestaw funkcji z tej trojki: SAML, OIDC, enterprise SSO i szerokie mozliwosci konfiguracji. Dobry wybor dla duzych zespolow z wymaganiami enterprise, ale cena szybko rosnie wraz z liczba MAU.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Dobry wybor dla zespolow, ktore chca bezpiecznego uwierzytelniania e-mail/haslo z RS512 JWT, 2FA i RBAC bez wchodzenia w duzy ekosystem. Proste REST API, przewidywalny cennik i niski koszt wdrozenia.',
			},
			alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
		},
		supabase: {
			...en.comparisons.supabase,
			breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
			title: 'Supabase vs. Auth0 vs. AuthFlow™',
			description: 'Porownanie Supabase Auth, Auth0 i AuthFlow™ krok po kroku, aby ulatwic wybor odpowiedniej warstwy auth dla twojej aplikacji.',
			summary: {
				supabaseTitle: 'Supabase Auth',
				supabaseBody: 'Dobre rozwiazanie dla zespolow, ktore chca open-source backendu mozliwego do self-hostingu. Supabase Auth oferuje logowanie spolecznosciowe, magic linki i gleboka integracje z Postgres, szczegolnie gdy juz korzystasz z Supabase jako bazy.',
				auth0Title: 'Auth0',
				auth0Body: 'Najbardziej rozbudowany zestaw funkcji: SAML, OIDC, enterprise SSO i zaawansowana konfiguracja. Mocna opcja dla duzych zespolow z wymaganiami compliance, ale koszty mocno rosna wraz z liczba aktywnych uzytkownikow miesiecznie.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Najlepsze rozwiazanie, gdy potrzebujesz skupionego i niezawodnego uwierzytelniania e-mail/haslo z RS512 JWT, 2FA i RBAC bez lock-inu platformowego. Proste REST API, przewidywalna stala cena i minimalny setup.',
			},
			alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
		},
	},
	features: {
		title: 'Dlaczego AuthFlow™ jest inne',
		description: 'Skupiamy sie na uwierzytelnianiu e-mail/haslo z tokenami JWT - fundamencie bezpiecznych aplikacji webowych. Zamiast robic wszystko, robimy jedna rzecz wyjatkowo dobrze.',
		emailPassword: {
			title: 'Logowanie e-mail/haslo',
			description: 'Proste i bezpieczne logowanie e-mail/haslo, ktore dziala niezawodnie. Bez zbednej zlozonosci - tylko logowanie, ktore uzytkownicy rozumieja.',
		},
		jwtTokens: {
			title: 'Zarzadzanie tokenami JWT',
			description: 'Poprawna obsluga tokenow JWT dla sesji, z bezpiecznym przechowywaniem i automatycznym odswiezaniem. Standard branzy, latwa integracja z API.',
		},
		developerApi: {
			title: 'API dla deweloperow',
			description: 'REST API z pelna dokumentacja, SDK i narzedziami deweloperskimi. Zbudowane przez deweloperow dla workflow DevSecOps.',
		},
	},
	testimonials: {
		title: 'Zaufane przez deweloperow na calym swiecie',
		testimonial1: {
			text: 'AuthFlow™ zaoszczedzil nam miesiace pracy. Integracja byla plynna, a funkcje bezpieczenstwa sa klasy enterprise.',
			author: 'Sarah Johnson',
			role: 'CTO, TechStart',
		},
		testimonial2: {
			text: 'Panel analityczny daje nam swietny wglad w zachowania uzytkownikow. Najlepsze rozwiazanie auth, z jakiego korzystalismy.',
			author: 'Mike Rodriguez',
			role: 'Lead Developer, AppCorp',
		},
		testimonial3: {
			text: 'Niezawodnosc jak skala i swietne wsparcie. Nasi uzytkownicy lubia plynne doswiadczenie logowania.',
			author: 'Alex Liu',
			role: 'Product Manager, InnovateLab',
		},
	},
	signIn: {
		title: 'Witamy ponownie',
		subtitle: 'Zaloguj sie do uwierzytelniania e-mail/haslo',
		card: {
			title: 'Logowanie organizacji',
			description: 'Wpisz e-mail wlasciciela organizacji, aby uzyskac dostep do panelu JWT',
		},
		form: {
			email: { label: 'E-mail', placeholder: 'owner@twojaorganizacja.com' },
			password: { label: 'Haslo', placeholder: 'Wpisz haslo' },
			signIn: 'Zaloguj sie',
			signingIn: 'Logowanie...',
			noAccount: { text: 'Nie masz organizacji?', link: 'Utworz' },
		},
		errors: {
			emailRequired: 'E-mail jest wymagany',
			failed: 'Logowanie nieudane',
			unexpected: 'Wystapil nieoczekiwany blad. Sprobuj ponownie.',
		},
		success: { message: 'Zalogowano pomyslnie!' },
		agreement: {
			text: 'Logujac sie, akceptujesz',
			terms: 'Warunki korzystania',
			and: 'oraz',
			privacy: 'Polityke prywatnosci',
		},
	},
	signUp: {
		title: 'Utworz swoja organizacje',
		subtitle: 'Uruchom organizacje z uwierzytelnianiem e-mail/haslo',
		card: {
			title: 'Utworz organizacje',
			description: 'Skonfiguruj organizacje, aby rozpoczac korzystanie z uwierzytelniania e-mail/haslo i tokenow JWT',
		},
		form: {
			organizationName: { label: 'Nazwa organizacji', placeholder: 'Twoja Organizacja' },
			organizationWebsite: { label: 'Strona organizacji', placeholder: 'twojaorganizacja.com' },
			emailOwner: { label: 'E-mail wlasciciela', placeholder: 'owner@twojaorganizacja.com' },
			password: { label: 'Haslo', placeholder: 'Utworz silne haslo' },
			confirmPassword: { label: 'Potwierdz haslo', placeholder: 'Potwierdz haslo' },
			agreeToTerms: 'Akceptuje Warunki korzystania i Polityke prywatnosci',
			acceptMarketing: 'Wysylaj mi aktualizacje produktu i e-maile marketingowe',
			createOrganization: 'Utworz organizacje',
			creatingOrganization: 'Tworzenie organizacji...',
			haveAccount: { text: 'Masz juz konto?', link: 'Zaloguj sie' },
		},
		errors: {
			organizationNameRequired: 'Nazwa organizacji jest wymagana',
			organizationWebsiteRequired: 'Strona organizacji jest wymagana',
			emailRequired: 'E-mail jest wymagany',
			passwordRequired: 'Haslo jest wymagane',
			passwordsDoNotMatch: 'Hasla nie sa zgodne',
			agreeToTermsRequired: 'Musisz zaakceptowac Warunki korzystania i Polityke prywatnosci',
			failed: 'Nie udalo sie utworzyc organizacji',
			unexpected: 'Wystapil nieoczekiwany blad. Sprobuj ponownie.',
		},
		success: { message: 'Organizacja zostala utworzona pomyslnie!' },
		trial: {
			description: 'Zacznij zarzadzac uwierzytelnianiem swojej organizacji juz dzis.',
			features: {
				emailPassword: 'Uwierzytelnianie e-mail/haslo',
				jwtTokens: 'Bezpieczenstwo tokenow JWT',
				simpleLogin: 'Proste logowanie',
			},
		},
	},
	common: {
		loading: 'Ladowanie...',
		error: 'Wystapil blad',
		success: 'Sukces',
		cancel: 'Anuluj',
		save: 'Zapisz',
		delete: 'Usun',
		edit: 'Edytuj',
		view: 'Zobacz',
		back: 'Wroc',
		next: 'Dalej',
		previous: 'Poprzedni',
		language: 'Jezyk',
	},
	seo: {
		title: 'AuthFlow™ - Bezpieczne uwierzytelnianie w prostym wydaniu',
		description: 'Uwierzytelnianie oparte na tokenach dla aplikacji webowych. Latwa integracja, bezpieczenstwo klasy enterprise i API przyjazne developerom. Rozpocznij darmowy okres probny juz dzis.',
		keywords: ['uwierzytelnianie', 'auth', 'bezpieczenstwo', 'API', 'uwierzytelnianie oparte na tokenach', 'JWT', 'narzedzia deweloperskie', 'bezpieczenstwo web', 'zarzadzanie uzytkownikami'],
	},
	footer: {
		description: 'Proste i niezawodne uwierzytelnianie e-mail/haslo z tokenami JWT. Zaufane przez deweloperow na calym swiecie.',
		product: 'Produkt',
		resources: 'Zasoby',
		company: 'Firma',
		apiReference: 'Dokumentacja API',
		about: 'O nas',
		support: 'Wsparcie',
		privacyPolicy: 'Polityka prywatnosci',
		termsOfService: 'Warunki korzystania',
		copyright: '© 2024 AuthFlow™. Wszelkie prawa zastrzezone.',
	},
	pricing: {
		title: 'Cennik AuthFlow™ - Proste koszty uwierzytelniania e-mail/haslo',
		description: 'Prosty i przejrzysty cennik dla uwierzytelniania e-mail/haslo z tokenami JWT. Zacznij za darmo i skaluj wraz ze wzrostem. Bez ukrytych oplat.',
		keywords: ['cennik uwierzytelniania', 'cennik email haslo', 'cennik JWT', 'prosty cennik auth', 'cennik auth dla developerow', 'koszty niezawodnego uwierzytelniania', 'cennik bezpiecznego logowania', 'cennik auth tokenowego', 'darmowy trial uwierzytelniania'],
		ogTitle: 'Cennik AuthFlow™ - Proste koszty uwierzytelniania e-mail/haslo',
		ogDescription: 'Wybierz idealny plan dla swoich potrzeb. Zacznij za darmo i skaluj z niezawodnym uwierzytelnianiem e-mail/haslo i JWT.',
		hero: {
			title: 'Prosty i przejrzysty',
			titleAccent: 'cennik uwierzytelniania',
			description: 'Wybierz idealny plan dla swoich potrzeb auth. Zacznij za darmo i skaluj z uwierzytelnianiem e-mail/haslo opartym o tokeny sesji JWT.',
		},
		breadcrumb: { product: 'Produkt', pricing: 'Cennik' },
		plans: {
			starter: {
				name: 'Starter',
				description: 'Idealny dla malych projektow i testowania auth e-mail/haslo',
				price: '$0',
				period: '/miesiac',
				features: {
					users: 'Do 10 aktywnych uzytkownikow miesiecznie',
					basicAuth: 'Podstawowe uwierzytelnianie e-mail/haslo',
					support: 'Standardowe wsparcie',
				},
				cta: 'Zacznij za darmo',
			},
			pro: {
				name: 'Pro',
				description: 'Dla rosnacych firm potrzebujacych niezawodnego auth e-mail/haslo',
				price: '$9.99',
				period: 'pierwszy miesiac, potem $19.99/miesiac',
				badge: 'Najpopularniejszy',
				features: {
					users: 'Nielimitowana liczba aktywnych uzytkownikow miesiecznie',
					advancedAuth: 'Zaawansowane uwierzytelnianie e-mail/haslo',
					support: 'Wsparcie priorytetowe',
				},
				cta: 'Rozpocznij darmowy okres probny',
				monthlyCta: 'Kup plan miesieczny',
				annualCta: 'Kup plan roczny',
			},
		},
		faq: {
			title: 'Najczesciej zadawane pytania',
			subtitle: 'Wszystko, co musisz wiedziec o naszych planach i cenach auth e-mail/haslo.',
			questions: {
				mau: { question: 'Co liczy sie jako miesiecznie aktywny uzytkownik?', answer: 'Miesiecznie aktywny uzytkownik (MAU) to unikalny uzytkownik, ktory uwierzytelnia sie co najmniej raz w miesiacu kalendarzowym.' },
				changePlans: { question: 'Czy moge zmienic plan w dowolnym momencie?', answer: 'Tak, mozesz zmienic plan w dowolnym momencie. Zmiany sa natychmiastowe, a rozliczenie proporcjonalne.' },
				freeTrial: { question: 'Czy jest darmowy okres probny?', answer: 'Tak, wszystkie platne plany maja 3-dniowy darmowy okres probny. Do rozpoczecia nie jest wymagana karta kredytowa.' },
				paymentMethods: { question: 'Jakie metody platnosci akceptujecie?', answer: 'Akceptujemy glowne karty kredytowe oraz Google Pay i Apple Pay.' },
			},
		},
		cta: {
			title: 'Gotowy, aby zaczac?',
			description: 'Dolacz do tysiecy deweloperow, ktorzy ufaja AuthFlow™ w zakresie niezawodnego auth e-mail/haslo. Zacznij darmowy okres probny juz dzis.',
			startTrial: 'Rozpocznij darmowy okres probny',
			contactSales: 'Skontaktuj sie ze sprzedaza',
		},
		footer: {
			description: 'Proste i niezawodne uwierzytelnianie e-mail/haslo z tokenami JWT. Zaufane przez deweloperow na calym swiecie.',
			product: { title: 'Produkt', features: 'Funkcje', pricing: 'Cennik', apiReference: 'Dokumentacja API' },
			resources: { title: 'Zasoby', gettingStarted: 'Pierwsze kroki', apiReference: 'Dokumentacja API', support: 'Wsparcie' },
			company: { title: 'Firma', about: 'O nas', privacy: 'Polityka prywatnosci', terms: 'Warunki korzystania' },
			copyright: '© 2024 AuthFlow™. Wszelkie prawa zastrzezone.',
		},
	},
	agent: {
		chatbot: {
			title: 'Asystent AuthFlow™',
			inputPlaceholder: 'Zapytaj o integracje /auth lub 2FA...',
			greeting: 'Prowadze wlascicieli organizacji przez dokladny kontrakt AuthFlow™ auth-user. Zapytaj o konfiguracje API key ownera, endpointy /auth, przeplywy 2FA, kolekcje Insomnia, granice frontend-backend lub usuwanie konta na stronie Settings.',
			downloadIntro: 'Uzyj tej karty bezposredniego pobierania, aby od razu pobrac kolekcje ownera do importu przez zespol.',
			downloadTitle: 'Pobierz kolekcje Insomnia',
			downloadButton: 'Pobierz',
			noAnswer: 'Nie otrzymalem uzytecznej odpowiedzi od agenta. Zapytaj o konkretny endpoint, przeplyw 2FA lub krok integracji backendu.',
			error: 'Wystapil blad przy laczeniu z asystentem. Nadal mozesz zapytac o kontrakt /auth, przeplywy 2FA lub kolekcje Insomnia i sprobowac ponownie.',
			toolNotFound: 'Nie znaleziono narzedzia',
		},
		tools: {
			verificationRecoveryDescription: 'Endpointy weryfikacji e-mail i odzyskiwania hasla',
			accountSteps: ['1. Zarejestruj sie jako wlasciciel organizacji na https://www.authflow.net/sign-up', '2. Utworz organizacje w panelu ownera', '3. Skopiuj API key organizacji z panelu', '4. Ustal wartosci role dla uzytkownikow auth', '5. Pobierz kolekcje AuthFlow™ auth-user dla Insomnia', '6. Przekaz kolekcje i dokladny kontrakt backendu zespolowi integracyjnemu'],
			accountManagement: ['Aby trwale usunac organizacje, przejdz do strony Settings w panelu AuthFlow™.', 'Uzyj sekcji Delete Account i wpisz DELETE, aby potwierdzic nieodwracalne usuniecie.'],
			reminder: 'API key ownera musi byc trzymany wylacznie po stronie backendu firmy.',
			environmentNotes: ['AUTHFLOW_API_KEY trzymaj tylko po stronie serwera.', 'AUTHFLOW_DEFAULT_ROLE jest opcjonalny, ale przydatny.', 'Frontend powinien wywolywac wlasne trasy backendu, a nie AuthFlow™ bezposrednio.'],
			backendGuidance: ['Pobieraj /auth/fooBar bezposrednio przed /auth/signUp lub /auth/login.', 'Uzywaj dokladnych nazw parametrow z publicznego kontraktu.', 'Gdy /auth/login zwroci requires2FA, kontynuuj odpowiednia trasa /auth/2fa.', 'Waliduj i pobieraj biezacego uzytkownika przez backend, a do frontendu wystawiaj tylko sesje aplikacji.'],
			insomniaContains: ['Wszystkie 12 publicznych endpointow /auth (w tym verify-email, resend-verify-email, forgot-password, reset-password, deleteUser)', 'Wszystkie 8 publicznych endpointow /auth/2fa', 'Zmienne srodowiskowe dla API key, role, tokenu fooBar, tempToken, tokenu sesji, TOTP, OTP e-mail i kodow odzyskiwania'],
			troubleshoot: {
				solutions: {
					cors: 'Jesli przegladarka wywoluje AuthFlow™ bezposrednio, zatrzymaj sie: przegladarka ma wywolywac twoj backend, a backend AuthFlow™.',
					'401_unauthorized': 'Sprawdz czy api_key, role i email zgadzaja sie z wartosciami uzytymi przy /auth/fooBar lub tworzeniu uzytkownika.',
					token_validation: 'Dla /auth/validate uzyj dokladnie pary sessionToken + email; nie myl z tempToken.',
					connection_failed: 'Potwierdz AUTHFLOW_BASE_URL = https://api.authflow.net i lacznosc backendu.',
					api_key_invalid: 'API key ownera musi byc kluczem z dashboardu zaczynajacym sie od af_.',
					foobar_expired: 'fooBar szybko wygasa; pobieraj go tuz przed sign-up/login.',
					verification_link: 'Token weryfikacyjny musi byc wazny i przekazany jako query do /auth/verify-email.',
					password_reset: 'Najpierw /auth/forgot-password, potem /auth/reset-password z tokenem z e-maila.',
					two_factor_flow: 'Jesli login zwraca requires2FA, uzywaj tempToken tylko na trasach /auth/2fa.',
					organization_deletion: 'Trwale usuniecie organizacji wykonuje sie w Settings > Delete Account po wpisaniu DELETE.',
					other: 'Porownaj zadanie z publicznym kontraktem: parametry, metoda HTTP i lokalizacja query/body/header.',
				},
				commonIssues: ['Frontend wywoluje AuthFlow™ bezposrednio', 'Brak api_key lub zla role na /auth/fooBar albo /auth/login', 'Bledne uzycie oldPassword/newPassword na /auth/changePassword', 'Mylenie tempToken z sessionToken', 'Wygasniety lub nieprawidlowy token weryfikacji', 'Brak /auth/forgot-password przed /auth/reset-password', 'Pominiecie wymiany 2FA po requires2FA', 'Proba usuniecia organizacji poza przeplywem Settings'],
			},
		},
	},
} as const
